const convertSlugToTitleCase = (slug) => {
  if (!slug) return '';
  if (typeof slug !== 'string' || !slug?.includes('-')) {
    throw new Error('Input must be a kebab-case string');
  }
  const uppercaseString = slug?.replaceAll('-', ' ');
  return uppercaseString?.replace(/\b\w/g, (c) => c.toUpperCase())?.trim();
};

export default convertSlugToTitleCase;
